import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Brain, ArrowRight, Sparkles, Trophy, Zap } from 'lucide-react';
import api from '../../services/api';
import './HomeQuiz.css';

const normalizeOptions = (opts) => {
  if (Array.isArray(opts)) return opts;
  if (typeof opts === 'string') {
    try {
      const parsed = JSON.parse(opts);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) { return []; }
  }
  return [];
};

const HomeQuiz = () => {
  const [preview, setPreview] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [categoryCount, setCategoryCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [qRes, cRes] = await Promise.all([
          api.get('/quiz/questions', { params: { count: 1 } }),
          api.get('/quiz/categories'),
        ]);
        if (cancelled) return;
        if (qRes.data.success && qRes.data.data.questions?.length) {
          const q = qRes.data.data.questions[0];
          setPreview({ ...q, options: normalizeOptions(q.options) });
        }
        if (cRes.data.success) {
          const cats = cRes.data.data.categories || [];
          setCategoryCount(cats.length);
          setTotalCount(cats.reduce((s, c) => s + (c.count || 0), 0));
        }
      } catch (e) {
        console.error('HomeQuiz load failed:', e);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!preview) return null;

  return (
    <section className="home-quiz home-fade-in">
      <div className="home-quiz__inner">
        <div className="home-quiz__left">
          <div className="home-quiz__badge">
            <Brain size={13} />
            <span>Knowledge Challenge</span>
          </div>
          <h2 className="home-quiz__title">
            Test your <span className="home-quiz__title-accent">market knowledge</span>
          </h2>
          <p className="home-quiz__desc">
            Curated must-know concepts for every trader. No sign-up required —
            each answer comes with a detailed explanation to help you learn as you go.
          </p>

          <div className="home-quiz__stats">
            <div className="home-quiz__stat">
              <Trophy size={16} />
              <span>{totalCount} Questions</span>
            </div>
            <div className="home-quiz__stat">
              <Sparkles size={16} />
              <span>{categoryCount} Categories</span>
            </div>
            <div className="home-quiz__stat">
              <Zap size={16} />
              <span>3 Difficulty Levels</span>
            </div>
          </div>

          <Link to="/quiz" className="home-quiz__cta">
            <Brain size={16} />
            <span>Start Challenge</span>
            <ArrowRight size={16} />
          </Link>
        </div>

        <div className="home-quiz__right">
          <div className="home-quiz__preview">
            <div className="home-quiz__preview-eyebrow">
              <Sparkles size={12} />
              <span>Sample Question</span>
            </div>
            <div className="home-quiz__preview-q">{preview.question}</div>
            <div className="home-quiz__preview-options">
              {preview.options.map((opt, i) => (
                <div key={i} className="home-quiz__preview-option">
                  <span className="home-quiz__preview-letter">
                    {String.fromCharCode(65 + i)}
                  </span>
                  <span className="home-quiz__preview-text">{opt}</span>
                </div>
              ))}
            </div>
            <div className="home-quiz__preview-hint">
              <ArrowRight size={12} />
              <span>Click "Start Challenge" to begin</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeQuiz;
